var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container",class:{ 'loader-opaque': _vm.isSubmitLoading }},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }